import { RefreshRounded } from '@mui/icons-material';
import { Button, Chip, Link, Typography } from '@mui/material';
import FlexContainer from 'components/FlexContainer';
import FormattedMessage from 'features/i18n/FormattedMessage';
import gtmIds from 'services/tracking/GTMIds';
import { withGtmInteraction } from 'services/tracking/withGtmInteraction';
import styled from 'styled-components';
import useTr from 'utils/hooks/useTr';
import { withTestId } from 'utils/utils';

type Props = {
  onRefreshClick: () => void;
  disabled: boolean;
};

export const RefreshCard = ({ disabled, onRefreshClick }: Props) => {
  const translate = useTr();

  return (
    <Root {...withTestId('check-claims-refresh-card')}>
      <FlexContainer direction="column">
        <FlexContainer direction="row" alignItems="center" gap="two">
          <Typography variant="subtitle1" fontWeight="bold" data-testid="check-claims-title">
            <FormattedMessage id="aiWriter.inspirations.factGrabbing.claim_list.refresh_card.title" />
          </Typography>
          <Chip
            variant="filled"
            color="info"
            size="small"
            label={translate('aiWriter.inspirations.factGrabbing.claim_list.refresh_card.beta')}
          />
        </FlexContainer>

        <Typography variant="body2" color="text.secondary">
          <FormattedMessage
            id="aiWriter.inspirations.factGrabbing.claim_list.refresh_card.subtitle"
            values={{
              a: (chunks: string) => (
                <Link
                  href={translate(
                    'aiWriter.inspirations.factGrabbing.claim_list.refresh_card.subtitle.link'
                  )}
                  target="_blank"
                  rel="noreferrer"
                >
                  {chunks}
                </Link>
              )
            }}
          />
        </Typography>
      </FlexContainer>

      <Button
        {...withGtmInteraction(gtmIds.aiWriter.factGrabbing.refresh)}
        {...withTestId('check-claims-refresh-button')}
        variant="text"
        startIcon={<RefreshRounded />}
        onClick={onRefreshClick}
        disabled={disabled}
      >
        <FormattedMessage id="aiWriter.inspirations.factGrabbing.claim_list.refresh_card.refresh.label" />
      </Button>
    </Root>
  );
};

const Root = styled(FlexContainer).attrs({
  direction: 'row',
  justifyContent: 'space-between',
  gap: 'small'
})`
  margin-left: ${({ theme }) => theme.spacings.four};
`;
